import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DurationService } from 'src/app/services/duration.service';
import { ProductLicence } from 'src/app/services/jsonrpc/shopify-server.service';
import { Role } from 'src/app/services/jsonrpc/user-server.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-shopify-licence-modal',
  templateUrl: './shopify-licence-modal.component.html',
  styleUrls: ['./shopify-licence-modal.component.scss']
})
export class ShopifyLicenceModalComponent implements OnInit {
  @Input() public roles: Role[] = [];
  @Input() public mails: string[] = [];
  @Input() public products: any[] = [];
  @Input() public model: ProductLicence = {
    product: null,
    pattern: '????-????-????',
    usage: 'unrestricted',
    precedence: 10000,
    volume: 1,
    mail: null,
    profile: {
      meta: { roles: [], confirmation: 'mail', duration: 'P1M' },
      settings: {},
      labels: {},
      enabled: true
    }
  };

  public readonly licenceUsageInfo = UserService.licenceUsageInfo;
  public product: { id: string; title: string };

  @Output() public onSubmit = new EventEmitter<ProductLicence>();

  public get title(): string {
    const action = this.model.uuid ? 'Update' : 'Create';
    return `${action} Shopify Licence`;
  }

  private _examplePattern: string;
  private _exampleKey: string;

  public get exampleKey(): string {
    if (!this._exampleKey || this.model.pattern !== this._examplePattern) {
      this._examplePattern = this.model.pattern;
      this._exampleKey = this.createRandomKey(this._examplePattern);
    }
    return this._exampleKey;
  }

  constructor(public duration: DurationService, public modal: NgbActiveModal) {}

  ngOnInit(): void {
    this.product = (this.model as any).item;
  }

  public isValid(): boolean {
    return this.isValidProduct() && this.isValidMail() && this.isValidPattern() && this.isValidRoles() && this.isValidDuration();
  }

  public submit() {
    if (this.model.description === '') {
      this.model.description = null;
    }
    this.onSubmit.emit(this.model);
    this.modal.close();
  }

  public isValidProduct(): boolean {
    return this.product != null && this.model.product != null;
  }

  public isValidMail(): boolean {
    return this.model.mail != null && this.mails.includes(this.model.mail);
  }

  public isValidDuration(): boolean {
    return this.isValidField(
      this.model.profile.meta.duration,
      /^P(?!$)(\d+(\.\d+)?Y)?(\d+(\.\d+)?M)?(\d+(\.\d+)?W)?(\d+(\.\d+)?D)?(T(?=\d)(\d+(\.\d+)?H)?(\d+(\.\d+)?M)?(\d+(\.\d+)?S)?)?$/,
      true
    );
  }

  public isValidRoles(): boolean {
    return this.roles.length == 0 || this.model.profile.meta.roles?.length > 0;
  }

  public isValidPattern(): boolean {
    return (
      this.isValidField(this.model.pattern, /^.*[\?_#].*$/, true) && this.isValidField(this.model.pattern, /^[\w\.\-\/+=\?#]{4,100}$/, true)
    );
  }

  private isValidField(value: any, pattern: RegExp, required: boolean): boolean {
    return value == null || value === '' ? !required : value.match(pattern) != null;
  }

  private createRandomKey(pattern: string): string {
    let result = '';
    for (let i = 0; i < pattern.length; i++) {
      let c = pattern.charAt(i);
      switch (c) {
        case '?':
          c = this.randomChar('ABCDEFGHJKLMNPQRSTUVWXYZ123456789');
          break;
        case '_':
          c = this.randomChar('ABCDEFGHJKLMNPQRSTUVWXYZ');
          break;
        case '#':
          c = this.randomChar('123456789');
          break;
      }
      result += c;
    }
    return result;
  }

  private randomChar(alphabet: string): string {
    return alphabet.charAt(Math.floor(Math.random() * alphabet.length));
  }
}
